import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../context/theme.context';
import '../style.css';
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  DataLabel,
  LineSeries,
} from '@syncfusion/ej2-react-charts';
import { getShiftGraph } from '../../../services/KPIsServices/KPIsServices';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import Scheduler from '../../../components/GlobalScheduler';

interface IProps {}
interface IState {
  graph1Data: Array<any>;
  graph11DataShift: Array<any>;
  graph11DataException: Array<any>;
  graph2Data: Array<any>;
  graph3Data: Array<any>;
}
let graph1ElementAlias: Array<any> = [];
let graph1Tickets: Array<any> = [];
let graph2ElementAlias: Array<any> = [];
let graph2Tickets: Array<any> = [];
let graph3ElementAlias: Array<any> = [];
let graph3Tickets: Array<any> = [];
let grap1Obj: ChartComponent;
let grap2Obj: ChartComponent;
let grap3Obj: ChartComponent;
let listObj: ListViewComponent;
const baseColor = 'e36927';
const colors = [
  '#7a42db',
  '#db6b16',
  '#db3016',
  '#30ed13',
  '#696969',
  '#22799c',
  '#db6b16',
  '#81a391',
  '#8216db',
  '#8e18c9',
  '#f2eeb8',
  '#00b6ff',
  '#2a1140',
  '#d736e3',
  '#d1c40f',
  '#a971ad',
  '#6c5f73',
  '#e6e3e8',
  '#f097b0',
  '#73eb89',
];
const ShiftCapacityGraph = () => {
  const [graph1Data, setGraph1Data] = useState<Array<any>>([]);
  const [graph2Data, setGraph2Data] = useState<Array<any>>([]);
  const [graph11DataShift, setGraph11DataShift] = useState<Array<any>>([]);
  const [graph11DataException, setGraph11DataException] = useState<Array<any>>(
    []
  );
  const [graph3Data, setGraph3Data] = useState<Array<any>>([]);
  const context = useContext(ThemeContext);
  const generateColor = (color: string, index: number) => {
    return colors[index];
  };
  const designData1 = (
    data: Array<any>,
    tickets: Array<any>,
    outPut: Array<any>
  ) => {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      const foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.team_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.team_code,
            color: generateColor(baseColor, counter),
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.element_alias === element.element_alias;
      });
      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.team_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          element_alias: element.element_alias,
          team_code: element.team_code,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  };

  const designData2 = (
    data: Array<any>,
    tickets: Array<any>,
    outPut: Array<any>
  ) => {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.team_code === element.team_code;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          element_alias: element.element_alias,
          team_code: element.team_code,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  };

  const designData3 = (
    data: Array<any>,
    tickets: Array<any>,
    outPut: Array<any>
  ) => {
    var counter: number = 0;
    data.forEach((el: any) => {
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.dayName === element.dayName;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          element_alias: element.element_alias,
          dayName: element.dayName,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  };

  const getShiftsGraph = (query: string) => {
    graph1ElementAlias = [];
    graph2ElementAlias = [];
    graph3ElementAlias = [];
    graph1Tickets = [];
    graph2Tickets = [];
    graph3Tickets = [];
    getShiftGraph(query)
      .then((el) => {
        designData1(el.data.dataG1, graph1Tickets, graph1ElementAlias);
        designData2(el.data.dataG2, graph2Tickets, graph2ElementAlias);
        designData3(el.data.dataG3, graph3Tickets, graph3ElementAlias);
        const theShift: Array<any> = [];
        const theException: Array<any> = [];
        el.data.dataG4.map((el: any) => {
          if (el.roster_type === 'Shift') {
            theShift.push({
              trade_code: el.trade_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          } else {
            theException.push({
              trade_code: el.trade_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          }
        });
        setGraph11DataShift(theShift);
        setGraph11DataException(theException);
        setGraph1Data(graph1ElementAlias);
        setGraph2Data(graph2ElementAlias);
        setGraph3Data(graph3ElementAlias);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const renderTemplateListElement = (el: any) => {
    return (
      <div className='eachPiece'>
        <div className='line'></div>
        <div className='eachTexts'>
          <span className='eachTeamText'>{el.element_alias}</span>
          <span className='eachTeamCountText'>{Math.abs(el.Y)}</span>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (context.isDataChangeKpiShift) {
      getShiftsGraph(Scheduler.AllFilterDAta);
      context.setDataChangeKpiShift(false);
    }
  }, [context.isDataChangeKpiShift]);
  useEffect(() => {
    getShiftsGraph(Scheduler.AllFilterDAta);
  }, []);
  return (
    <div className='main-chart-content'>
      <div className='chart1' style={{ width: '28%' }}>
        <div className='left-component-first'>
          <span>
            <b># of Hours By Team</b>
          </span>
        </div>
        <div className='left-component-three'>
          <ChartComponent
            id='shiftcharts'
            style={{ textAlign: 'center' }}
            ref={(el) => {
              grap1Obj = el as ChartComponent;
            }}
            primaryXAxis={{
              valueType: 'Category',
              interval: 1,
              majorGridLines: { width: 0 },
              labelStyle: {
                size: '8px',
              },
            }}
            primaryYAxis={{
              edgeLabelPlacement: 'Shift',
              majorTickLines: { width: 1 },
              majorGridLines: { width: 0 },
              minorGridLines: { width: 1 },
              minorTickLines: { width: 1 },
              labelFormat: '{value}',
              labelStyle: {
                size: '8px',
              },
              lineStyle: { width: 0 },
            }}
            chartArea={{ border: { width: 0 } }}
            width={'100%'}
            tooltip={{ enable: true }}
            height={'190px'}
            background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
            legendSettings={{
              textStyle: {
                color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                size: '8px',
              },
              position: 'Top',
            }}
          >
            <Inject
              services={[
                StackingColumnSeries,
                DataLabel,
                Category,
                Legend,
                Tooltip,
                LineSeries,
              ]}
            />
            <SeriesCollectionDirective>
              {graph1Tickets.map((el: any, index: number) => {
                if (el.type === 'Exception') {
                  return (
                    <SeriesDirective
                      zOrder={1000000}
                      key={Math.random()}
                      dataSource={graph1Data}
                      xName='element_alias'
                      yName={`y${index}`}
                      animation={{ enable: true }}
                      name={el.value}
                      type='Line'
                      fill={el.color}
                      marker={{ visible: true, width: 10, height: 10 }}
                    ></SeriesDirective>
                  );
                } else {
                  return (
                    <SeriesDirective
                      key={Math.random()}
                      dataSource={graph1Data}
                      xName='element_alias'
                      yName={`y${index}`}
                      name={el.value}
                      type='StackingColumn'
                      fill={el.color}
                      cornerRadius={{
                        topLeft: 0,
                        topRight: 0,
                      }}
                    ></SeriesDirective>
                  );
                }
              })}
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
        <div className='left-component-fourr'></div>
      </div>
      <div className='chart2' style={{ width: '28%' }}>
        <div className='blanc-text'>
          <span>
            <b># of Hours by Exception Element</b>
          </span>
        </div>
        <ChartComponent
          id='shiftcharts2'
          style={{ textAlign: 'center' }}
          ref={(el) => {
            grap2Obj = el as ChartComponent;
          }}
          primaryXAxis={{
            majorGridLines: { width: 0 },
            minorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            minorTickLines: { width: 0 },

            lineStyle: { width: 0 },
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            labelStyle: {
              size: '8px',
            },
          }}
          primaryYAxis={{
            lineStyle: { width: 0 },
            majorTickLines: { width: 1 },
            majorGridLines: { width: 0 },
            minorGridLines: { width: 1 },
            minorTickLines: { width: 1 },
            labelFormat: '{value}',
            labelStyle: {
              size: '8px',
            },
          }}
          width={'100%'}
          chartArea={{ border: { width: 0 } }}
          tooltip={{ enable: true }}
          height={'190px'}
          background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
          legendSettings={{
            textStyle: {
              color: context.isDarkMode ? '#EAEAEA' : '#15202B',
              size: '8px',
            },
            position: 'Top',
          }}
        >
          <Inject
            services={[StackingColumnSeries, Category, Legend, Tooltip]}
          />
          <SeriesCollectionDirective>
            {graph2Tickets.map((el: any, index: number) => {
              return (
                <SeriesDirective
                  key={Math.random()}
                  dataSource={graph2Data}
                  xName='team_code'
                  yName={`y${index}`}
                  name={el.value}
                  type='StackingColumn'
                  fill={el.color}
                ></SeriesDirective>
              );
            })}
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
      <div className='chart3' style={{ width: '28%' }}>
        <div>
          <span>
            <b># of Hours by Exception Element</b>
          </span>
        </div>
        <div>
          <ChartComponent
            id='shiftcharts3'
            style={{ textAlign: 'center' }}
            ref={(el) => {
              grap3Obj = el as ChartComponent;
            }}
            primaryXAxis={{
              majorGridLines: { width: 0 },
              minorGridLines: { width: 0 },
              majorTickLines: { width: 0 },
              minorTickLines: { width: 0 },
              interval: 1,
              lineStyle: { width: 0 },
              labelIntersectAction: 'Rotate45',
              valueType: 'Category',
              labelStyle: {
                size: '8px',
              },
            }}
            primaryYAxis={{
              lineStyle: { width: 0 },
              majorTickLines: { width: 1 },
              majorGridLines: { width: 0 },
              minorGridLines: { width: 1 },
              minorTickLines: { width: 1 },
              labelFormat: '{value}',
              labelStyle: {
                size: '8px',
              },
            }}
            width={'100%'}
            chartArea={{ border: { width: 0 } }}
            tooltip={{ enable: true }}
            height={'190px'}
            background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
            legendSettings={{
              textStyle: {
                color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                size: '8px',
              },
              position: 'Top',
            }}
          >
            <Inject
              services={[StackingColumnSeries, Category, Legend, Tooltip]}
            />
            <SeriesCollectionDirective>
              {graph3Tickets.map((el: any, index: number) => {
                return (
                  <SeriesDirective
                    key={Math.random()}
                    dataSource={graph3Data}
                    xName='dayName'
                    yName={`y${index}`}
                    name={el.value}
                    type='StackingColumn'
                    fill={el.color}
                  ></SeriesDirective>
                );
              })}
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
      </div>
      <div className='detail-content'>
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          {graph11DataShift.length > 0 ? (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <span>Shift</span>
              <ListViewComponent
                ref={(e) => {
                  listObj = e as ListViewComponent;
                }}
                className={'hiddenListElement'}
                id='sample-list-flat'
                dataSource={graph11DataShift}
                template={renderTemplateListElement.bind(this)}
                cssClass='e-list-template'
                animation={{
                  effect: 'SlideLeft',
                  duration: 500,
                  easing: 'ease',
                }}
                height={'200px'}
              ></ListViewComponent>
            </div>
          ) : null}
          {graph11DataException.length > 0 ? (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <span>Exception</span>
              <ListViewComponent
                ref={(e) => {
                  listObj = e as ListViewComponent;
                }}
                className={'hiddenListElement'}
                id='sample-list-flat'
                dataSource={graph11DataException}
                template={renderTemplateListElement.bind(this)}
                cssClass='e-list-template'
                animation={{
                  effect: 'SlideLeft',
                  duration: 500,
                  easing: 'ease',
                }}
                height={'200px'}
              ></ListViewComponent>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default ShiftCapacityGraph;